import React from "react"
import {
  Menu, MenuItem, MenuItemProps, MenuList, Portal, Kbd,
} from "@chakra-ui/react"

type Props = {
  /** Where the pointer was, in screen pixels. */
  x: number
  y: number
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

/** A right-click menu at the pointer; its items are children (`EditorContextMenuItem`). */
export const EditorContextMenu = ({
  x, y, isOpen, onClose, children,
}: Props) => (
  <Menu isOpen={isOpen} onClose={onClose} closeOnBlur closeOnSelect>
    <Portal>
      <MenuList
        position="fixed"
        left={`${x}px`}
        top={`${y}px`}
        minW="12rem"
        zIndex={99999}
        // Keeps the press from reaching the canvas and changing the selection
        onMouseDown={(e) => e.stopPropagation()}
      >
        {children}
      </MenuList>
    </Portal>
  </Menu>
)

type ItemProps = MenuItemProps & {
  /** The keyboard shortcut shown on the right, e.g. "⌘ D". */
  shortcut?: string
}

export const EditorContextMenuItem = ({ shortcut, children, ...props }: ItemProps) => (
  <MenuItem justifyContent="space-between" {...props}>
    {children}
    {shortcut && <Kbd>{shortcut}</Kbd>}
  </MenuItem>
)
